import { createContext, useContext } from "react";

import type { TouchpointAttributes } from "hooks/api/use-touchpoints";

type CreativeTableSelection = {
  selectedIds: string[];
  setSelectedIds: (ids: string[] | ((prev: string[]) => string[])) => void;
  displayedTouchpoints: TouchpointAttributes[];
  isCurrentPageAllSelected: boolean;
};

/**
 * Selection reaches the checkbox cells through context rather than through the column definitions:
 * `flexRender` mounts a column's `cell` as a component, so a column rebuilt on every selection change
 * remounts every row — and the clicked checkbox loses its ripple mid-animation.
 */
export const CreativeTableSelectionContext = createContext<CreativeTableSelection | null>(null);

export const useCreativeTableSelection = (): CreativeTableSelection => {
  const selection = useContext(CreativeTableSelectionContext);

  if (!selection) {
    throw new Error("useCreativeTableSelection must be used within CreativeTable");
  }

  return selection;
};
